document.addEventListener("DOMContentLoaded", function () {

    const mobileNav = document.getElementById("mobileNav");
    const mobileMenuWrapper = document.getElementById("mobile_menu");
    const closeBtn = document.querySelector(".close-btn");
    const sidebarOverlay = document.querySelector(".sidebar-overlay");
     const itemMobileTop = document.querySelector(".item-mobile-top");

    // Close menu
    closeBtn.addEventListener("click", function () {

        // close inner mobile nav
        mobileNav.classList.remove("active");

        // close wrapper
        if (mobileMenuWrapper) {
            mobileMenuWrapper.classList.remove("act");
        }

        // close sidebar overlay
        if (sidebarOverlay) {
            sidebarOverlay.classList.remove("act");
        }
        // close sidebar overlay
        if (itemMobileTop) {
            itemMobileTop.classList.remove("act");
        }
    });

    // Submenu toggle
    document.querySelectorAll(".submenu-toggle").forEach(toggle => {
        toggle.addEventListener("click", function (e) {
            e.stopPropagation();
            const parent = this.closest(".menu-item");
            parent.classList.toggle("open");
        });
    });

});
